<template>
  <div v-if="productType==='plot'" class="container">
    <van-image class="pick-image" height="150px" width="150px" :src="traceData.productPic" round fit="cover" />
    <div class="name">
      {{ traceData.productName }}
    </div>
    <div class="plant-standard">
      {{ traceData.productPlantStandard }}农产品 <van-icon name="play" />
    </div>
    <div class="bottom-content">
      <div class="time item">
        <div class="text">
          {{ formatTime(traceData.productPickTime, 'YYYY-MM-DD') }}
        </div>
        <div class="footnote">
          采收时间
        </div>
      </div>
      <div class="type item">
        <div class="text">
          {{ plantTypeData[traceData.productCropType] ? plantTypeData[traceData.productCropType].name : '' }}
        </div>
        <div class="footnote">
          作物类别
        </div>
      </div>
    </div>
  </div>
  <div v-else class="container">
    <van-image class="pick-image" height="150px" width="150px" :src="traceData.productPhoto|firstImg" round fit="cover" />
    <div class="name">
      {{ traceData.productName }}
    </div>
    <div class="bottom-content">
      <div class="time item">
        <div class="text">
          {{ formatTime(traceData.packingTime, 'YYYY-MM-DD') }}
        </div>
        <div class="footnote">
          包装时间
        </div>
      </div>
      <div class="type item">
        <div class="text">
          {{ traceData.specificationQuantity }}{{ traceData.specificationUint }}/{{ traceData.specificationPacking }}
        </div>
        <div class="footnote">
          规格
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firstImg } from '@/filter'
import { formatTime } from '@/utils/convert/convertTime'
import { PLANT_TYPE_DATE } from '@/constant/common'

export default {
  name: 'PickInfo',
  filters: {
    firstImg
  },
  props: {
    traceData: {
      type: Object,
      default() {
        return {}
      }
    },
    productType: {
      type: String,
      default: 'plot'
    }
  },
  data() {
    return {
      plantTypeData: PLANT_TYPE_DATE
    }
  },
  methods: {
    formatTime
  }
}
</script>

<style lang='less' scoped>
.container {
  background: #ffffff;
  text-align: center;
}
.pick-image {
  margin-top: 44px;
}
.name {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 24px;
  color: #323332;
  margin-top: 23px;
}
.plant-standard {
  background: #20caa0;
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  padding: 0 10px;
  border-radius: 4px;
  color: #FFFFFF;
  margin-top: 13px;
}
.bottom-content {
  padding: 14px 40px;
  margin-top: 21px;
  font-family: Microsoft YaHei;
  background: linear-gradient(#707070,#707070) center center no-repeat;
  background-size: 1px 60%;
  display: flex;
  justify-content: space-between;
  > .item {
    width: 50%;
    &.time {
      max-width: 100px;
    }
  }
  .text {
    font-size: 14px;
    font-weight: 400;
    color: #20CAA0;
  }
  .footnote {
    margin-top: 7px;
    font-size: 12px;
    font-weight: 400;
    color: #323332;
  }
}
</style>
